import { render } from "./AttachmentList.vue?vue&type=template&id=eca58782&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"

import "./AttachmentList.vue?vue&type=style&index=0&id=eca58782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca58782"]])

export default __exports__